<ng-container *ngIf="sponsor.hasWebsite(); else withoutWebsite">
  <a href="{{ sponsor.url }}" target="_blank" class="sponsor-container card-shadow" [class.simpleDesign]="simpleDesign">
    <img *ngIf="resizedImageSrc != null" class="logo" src="{{ resizedImageSrc }}" alt="Sponsor Image">
    <div class="name-wrapper" *ngIf="resizedImageSrc == null">
      <span class="name">{{ sponsor.name }}</span>
      <span class="website" *ngIf="sponsor.hasWebsite()">{{ sponsor.getWebsiteWithoutHttp() }}</span>
    </div>
  </a>
</ng-container>

<ng-template #withoutWebsite>
  <div class="sponsor-container card-shadow" [class.simpleDesign]="simpleDesign">
    <img *ngIf="resizedImageSrc != null" class="logo" src="{{ resizedImageSrc }}" alt="Sponsor Image">
    <div class="name-wrapper" *ngIf="resizedImageSrc == null">
      <span class="name">{{ sponsor.name }}</span>
    </div>
  </div>
</ng-template>
